import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import { getBankPromotionFromLocalStorage } from '@/data/Content/BanksPromotion';
import { Skeleton, Typography } from '@mui/material';
import { useMemo } from 'react';

export const RegisterTitleContentRecommendation = () => {
	const emsName = useMemo(() => {
		const bankPromotion = getBankPromotionFromLocalStorage();
		return bankPromotion ? `DPV2RegisterTitle_${bankPromotion}` : 'register_unknown';
	}, []);

	return (
		<ContentRecommendation
			id={emsName}
			properties={{
				emsName,
			}}
			withoutFrame
			loadingElement={
				<>
					<Skeleton variant="text" width="300px" height={40} />
					<Skeleton variant="text" width="150px" height={30} />
				</>
			}
			emptyElement={
				<>
					<Typography
						component={'h1'}
						sx={{
							fontSize: { md: 'var(--font-size-xl)', xs: 'var(--font-size-lg)' },
							fontWeight: '800',
							letterSpacing: '0px',
							color: '#2C2C2C',
							textTransform: 'uppercase',
							opacity: 1,
						}}
					>
						{'REGÍSTRATE'}
					</Typography>
					<Typography
						component={'h2'}
						sx={{
							fontSize: 'var(--font-size-sm)',
							fontWeight: 'normal',
							letterSpacing: '0px',
							color: '#2C2C2C',
							opacity: 1,
							mt: '0px !important',
						}}
					>
						{'Llena tus datos y disfruta de los beneficios'}
					</Typography>
				</>
			}
		/>
	);
};
